module.exports = __webpack_public_path__ + "img/162.ea3b56de.jpg";